export default "__VITE_ASSET__CRdEkDOy__"